import { render, staticRenderFns } from "./I18nGroupMultirow.vue?vue&type=template&id=7801344a&"
import script from "./I18nGroupMultirow.vue?vue&type=script&lang=js&"
export * from "./I18nGroupMultirow.vue?vue&type=script&lang=js&"
import style0 from "./I18nGroupMultirow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports